<template>
  <div class="modal" id="user_search_modal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <a id="filter_search_close" class="btn model-c-close-bnt" data-dismiss="modal" aria-hidden="true"><i
                  class="fa fa-close fa-2x fa-c-close-icon"></i></a>
          <h4 class="modal-title btn-c-blue"><i class="fa fa-search fa-lg btn-c-blue"></i> Filter Search</h4>
        </div>
        <form name="search_filter_form" id="search_filter_form" method="post"
              action="http://www.awesome.dev/admin/user/filtersearch">
          <div class="modal-body">
            <div class="portlet">
              <div class="portlet-title">
                <div class="caption btn-c-blue"><i class="fa fa-filter blue"></i>Main Filters</div>
                <div class="tools">
                  <a href="javascript:void(0);" class="collapse" data-original-title="" title="">
                  </a>
                </div>
              </div>
              <div class="portlet-body">
                <div class="row">
                  <div class="col-sm-4">
                    <select class="form-control" name="favorite_filter" id="favorite_filter">
                      <option value="" disabled selected>Favorite Filters</option>
                      <option value="1">filter_zozP</option>
                      <option value="2">asdasdasdsad</option>
                      <option value="3">filter_WYsh</option>
                      <option value="4">Arab Country Filter</option>
                      <option value="5">filter_LeLh</option>
                      <option value="6">filter_OfRs</option>
                      <option value="7">filter_PFQ1</option>
                      <option value="8">filter_m1DP</option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <input type="hidden" name="select_user_type" id="select_user_type" value="">
                    <span class="caption-subject font-blue-sharp">Current User Type</span>
                    <br>
                    <select class="form-control" name="current_user_type[]" id="current_user_type"
                            placeholder="Current User Type" multiple>
                      <option value="i12">All Individuals</option>
                      <option value="b12">All Businesses</option>
                      <option value="1">Personal User</option>
                      <option value="2">Personal User</option>
                      <option value="3">Employee User</option>
                      <option value="4">B1G1 Member</option>
                      <option value="5">B1G1 Partner</option>
                      <option value="6">Premium Partnership</option>
                      <option value="7">Business for Good Partnership</option>
                      <option value="8">Trial Partner</option>
                      <option value="9">Guest User</option>
                      <option value="10">Premium Personal User</option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <span class="caption-subject font-blue-sharp">Previous User Type</span>
                    <br>
                    <select class="form-control" name="previous_user_type[]" id="previous_user_type"
                            placeholder="Previous User Type" multiple>
                      <option value="1">Personal User</option>
                      <option value="2">Personal User</option>
                      <option value="3">Employee User</option>
                      <option value="4">B1G1 Member</option>
                      <option value="5">B1G1 Partner</option>
                      <option value="6">Premium Partnership</option>
                      <option value="7">Business for Good Partnership</option>
                      <option value="8">Trial Partner</option>
                      <option value="9">Guest User</option>
                      <option value="10">Premium Personal User</option>
                    </select>
                  </div>
                </div>
                <div class="row search-c-filter">
                  <div class="col-sm-4">
                    <input type="text" value="" placeholder="Key Word (Name, UID, Email)" id="keyword" name="keyword"
                           class="form-control valid  margin-c2-bottom" aria-required="true"
                           aria-describedby="userpersonalfirstname-error userpersonalfirstname-error"
                           aria-invalid="false">

                    <select class="form-control margin-c2-bottom" placeholder="Registration Type (Joining Method)"
                            name="reg_type[]" id="reg_type" multiple>
                      <!-- <option value="1">Event registration</option>
                      <option value="2">Online registration (Organic)</option>
                      <option value="3">Other registration</option>
                      <option value="4">Online registration (Referral)</option> -->
                      <option value="2">Organic Search (eg. Google)</option>
                      <option value="4">Referral</option>
                      <option value="1">Event</option>
                      <option value="5">LinkedIn</option>
                      <option value="6">Social Media</option>
                      <option value="7">Advertisement</option>
                      <option value="3">Others</option>
                    </select>
                    <select class="form-control select2-multiple margin-c2-bottom" name="refered_type[]"
                            id="refered_type" multiple placeholder="Referred by (Company Name)">
                    </select>
                  </div>
                  <div class="col-sm-4  blue-stripe text-center">
                    <span class="caption-subject font-blue-sharp">Joining date (Range)</span>
                    <br>
                    <div class="input-group input-medium date " style="margin-bottom: 2px;"
                         data-date-format="yyyy-mm-dd">
                      <input type="text" class="form-control date-picker date-c-picker" id="joining_date_from"
                             name="joining_date_from" placeholder="From mm/dd/year" value="">
                      <span class="input-group-btn ">
                                                    <button class="btn default" id="startdateexpiry" type="button"><i
                                                            class="fa fa-calendar"></i></button>
                                               </span>
                    </div>
                    <div class="input-group input-medium date " data-date-format="yyyy-mm-dd">
                      <input type="text" class="form-control date-picker date-c-picker mycalender22"
                             id="joining_date_to" name="joining_date_to" value="" placeholder="To mm/dd/year">
                      <span class="input-group-btn ">
                                             <button class="btn default" type="button"><i
                                                     class="fa fa-calendar"></i></button>
                                        </span>
                    </div>
                  </div>

                  <div class="col-sm-4 blue-stripe">
                    <span class="caption-subject font-blue-sharp">Upgrade/downgrade Date (Range)</span>
                    <br>
                    <div style="margin-bottom: 2px;" class="input-group input-medium date "
                         data-date-format="dd-mm-yyyy">
                      <input type="text" class="form-control date-picker date-c-picker" id="upgrade_from"
                             name="upgrade_from" value="" placeholder="From mm/dd/year">
                      <span class="input-group-btn ">
                                            <button class="btn default" type="button"><i
                                                    class="fa fa-calendar"></i></button>
                                        </span>
                    </div>

                    <div class="input-group input-medium date " data-date-format="dd-mm-yyyy">
                      <input type="text" class="form-control date-picker date-c-picker" id="upgrade_to"
                             name="upgrade_to" value="" placeholder="To mm/dd/year">
                      <span class="input-group-btn ">
                                             <button class="btn default" type="button"><i
                                                     class="fa fa-calendar"></i></button>
                                        </span>
                    </div>
                  </div>

                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <select class="form-control" name="user_status" id="user_status">
                      <option value="" selected>User Status (All)</option>
                      <option value="0">Live</option>
                      <option value="1">Blocked</option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <span class="caption-subject font-blue-sharp">Joining date (custom)</span>
                    <br>
                    <select class="form-control" name="joining_custom" id="joining_custom">
                      <option selected="" value="" disabled>Select a custom range</option>
                      <option value="l1 month">less than 1 month ago</option>
                      <option value="l3 month">less than 3 month ago</option>
                      <option value="l6 month">less than 6 month ago</option>
                      <option value="l1 year">less than 1 year ago</option>
                      <option value="l2 year">less than 2 year ago</option>
                      <option value="l3 year">less than 3 year ago</option>
                      <option value="" disabled>--------------------</option>
                      <option value="m1 month">more than 1 month ago</option>
                      <option value="m3 month">more than 3 month ago</option>
                      <option value="m6 month">more than 6 month ago</option>
                      <option value="m1 year">more than 1 year ago</option>
                      <option value="m1 year">more than 2 year ago</option>
                      <option value="m1 year">more than 3 year ago</option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <span class="caption-subject font-blue-sharp">Upgrade/downgrade date (custom)</span>
                    <br>
                    <select class="form-control" name="joining_down_custom" id="joining_down_custom">
                      <option selected="" value="" disabled>Select a custom range</option>
                      <option value="l1 month">less than 1 month ago</option>
                      <option value="l3 month">less than 3 month ago</option>
                      <option value="l6 month">less than 6 month ago</option>
                      <option value="l1 year">less than 1 year ago</option>
                      <option value="l2 year">less than 2 year ago</option>
                      <option value="l3 year">less than 3 year ago</option>
                      <option value="" disabled>--------------------</option>
                      <option value="m1 month">more than 1 month ago</option>
                      <option value="m3 month">more than 3 month ago</option>
                      <option value="m6 month">more than 6 month ago</option>
                      <option value="m1 year">more than 1 year ago</option>
                      <option value="m1 year">more than 2 year ago</option>
                      <option value="m1 year">more than 3 year ago</option>
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-4">
                    <select class="form-control" name="user_country[]" id="user_country" placeholder="User Country"
                            multiple>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <select class="form-control" name="user_state[]" id="user_state" placeholder="User State" multiple>
                    </select>
                  </div>
                  <div class="col-sm-4">
                  </div>
                </div>

              </div>
            </div>

            <div class="portlet">
              <div class="portlet-title">
                <div class="caption btn-c-blue">
                  <i class="fa fa-suitcase"></i>Business Account Filters
                </div>
                <div class="tools">
                  <a href="javascript:void(0);" class="expand" data-original-title="" title="">
                  </a>
                </div>
              </div>
              <div class="portlet-body" style="display: none;">
                <div class="row">
                  <div class="col-sm-4">
                    <select class="form-control margin-c2-bottom" name="bus_name" id="bus_name">
                      <option selected="selected" value="">Business Name (Personal Name)</option>
                    </select>
                    <select class="form-control margin-c2-bottom" name="bus_acc_status" id="bus_acc_status">
                      <option selected="selected" value="">Business Account Status</option>
                      <option value="">Active</option>
                      <option value="">Dormant</option>
                      <option value="">Downgraded</option>
                      <option value="">Blocked</option>
                      <option value="">Upgraded</option>
                    </select>
                    <select class="form-control" name="bus_package" id="bus_package">
                      <option selected="selected" value="">Membership Package</option>
                      <option value="1">Tiny</option>
                      <option value="2">Small</option>
                      <option value="3">SME</option>
                      <option value="4">SME PLUS</option>
                    </select>
                  </div>
                  <div class="col-sm-4 blue-stripe">
                    <span class="caption-subject font-blue-sharp">Registration Date (Range)</span>
                    <br>
                    <div style="margin-bottom: 2px;" class="input-group input-medium date "
                         data-date-format="yyyy-mm-dd">
                      <input type="text" class="form-control date-picker date-c-picker mycalender22" id="reg_date_from"
                             name="reg_date_from" value="" placeholder="From mm/dd/year">
                      <span class="input-group-btn ">
                                        <button class="btn default" type="button"><i
                                                class="fa fa-calendar"></i></button>
                                     </span>
                    </div>
                    <div class="input-group input-medium date " data-date-format="yyyy-mm-dd">
                      <input type="text" class="form-control date-picker date-c-picker mycalender22" id="reg_date_to"
                             name="reg_date_to" value="" placeholder="To mm/dd/year">
                      <span class="input-group-btn ">
                                        <button class="btn default" type="button"><i
                                                class="fa fa-calendar"></i></button>
                                         </span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <select class="form-control margin-c2-bottom" name="bus_country[]" id="bus_country"
                            placeholder="Business Country" multiple>
                    </select>
                    <select class="form-control margin-c2-bottom" name="bus_state[]" id="bus_state"
                            placeholder="Business State" multiple>
                    </select>
                    <input type="text" class="form-control margin-c2-bottom" id="bus_city" name="bus_city"
                           placeholder="Business City" value="">
                    <select class="form-control margin-c2-bottom" name="bus_cate" id="bus_cate">
                      <option selected="selected" value="">Business Main Category</option>
                      <option value="">B-to-B</option>
                      <option value="">B-to-C</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <span class="caption-subject font-blue-sharp">Joining Date (Custom)</span>
                    <br>
                    <select class="form-control" name="bus_cus_date" id="bus_cus_date">
                      <option selected="selected" value="">Select a custom range</option>
                      <option value="l1 month">less than 1 month ago</option>
                      <option value="l3 month">less than 3 month ago</option>
                      <option value="l6 month">less than 6 month ago</option>
                      <option value="l1 year">less than 1 year ago</option>
                      <option value="l2 year">less than 2 year ago</option>
                      <option value="l3 year">less than 3 year ago</option>
                      <option value="" disabled>--------------------</option>
                      <option value="m1 month">more than 1 month ago</option>
                      <option value="m3 month">more than 3 month ago</option>
                      <option value="m6 month">more than 6 month ago</option>
                      <option value="m1 year">more than 1 year ago</option>
                      <option value="m1 year">more than 2 year ago</option>
                      <option value="m1 year">more than 3 year ago</option>
                    </select>
                  </div>

                  <div class="col-sm-4">
                    <span class="caption-subject font-blue-sharp">Industry</span>
                    <br>
                    <select class="form-control input-medium" name="bus_indus[]" id="bus_indus" placeholder="Industry"
                            multiple>
                      <!--                                            <option selected="" value="" disabled>Industry</option>-->
                      <option value="1">Accounting</option>
                      <option value="2">Agriculture</option>
                      <option value="3">Automobile</option>
                      <option value="4">Building Services</option>
                      <option value="5">Childcare</option>
                      <option value="6">Coaching & Training</option>
                      <option value="7">Computing</option>
                      <option value="8">Consulting</option>
                      <option value="9">Design & Photography</option>
                      <option value="10">Domestic Services</option>
                      <option value="11">Education</option>
                      <option value="12">Electronics</option>
                      <option value="13">Event & Venue</option>
                      <option value="14">Fashion</option>
                      <option value="15">Financial & Insurance Services</option>
                      <option value="16">Food & Beverages</option>
                      <option value="17">Gift</option>
                      <option value="18">Grocery</option>
                      <option value="19">Health & Wellness</option>
                      <option value="20">Hobby</option>
                      <option value="21">Hospitality</option>
                      <option value="22">Household Items</option>
                      <option value="23">Legal Services</option>
                      <option value="24">Marketing & PR</option>
                      <option value="25">Material Supplies</option>
                      <option value="26">Medical Care</option>
                      <option value="27">Music & Entertainment</option>
                      <option value="28">News & Publications</option>
                      <option value="29">Office & Plant Rental</option>
                      <option value="30">Office Fitting</option>
                      <option value="31">Other Business Resources</option>
                      <option value="32">Other Business Services</option>
                      <option value="33">Online Shopping</option>
                      <option value="34">Other Personal Services</option>
                      <option value="35">Personal Care</option>
                      <option value="36">Pet Care</option>
                      <option value="37">Phone & Communication</option>
                      <option value="38">Printing & Stationery</option>
                      <option value="39">Real Estate</option>
                      <option value="40">Recruitment & HR</option>
                      <option value="41">Repairs & Maintenance</option>
                      <option value="42">Security & Safety Services</option>
                      <option value="43">Shipping & Packaging</option>
                      <option value="44">Sports & Leisure</option>
                      <option value="45">Tools & Equipment</option>
                      <option value="46">Transportation</option>
                      <option value="47">Travel & Accommodations</option>
                      <option value="48">Utilities</option>
                      <option value="49">Web Services</option>
                    </select>
                  </div>
                </div>

              </div>
            </div>
            <div class="portlet">
              <div class="portlet-title">
                <div class="caption btn-c-blue">
                  <i class="fa fa-tag"></i>Tags & Connection Filters
                </div>
                <div class="tools">
                  <a href="javascript:void(0);" class="expand" data-original-title="" title="">
                  </a>
                </div>
              </div>
              <div class="portlet-body" style="display: none;">
                <div class="row margin-c2-bottom">
                  <div class="col-sm-4 blue-stripe">
                    <span class="caption-subject font-blue-sharp">INCLUDE</span>
                    <select class="form-control input-medium margin-c2-bottom" name="include_tag[]" id="include_tag"
                            multiple>
                    </select>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer" style="text-align: center !important;">
            <button type="submit" class="btn orange btn-c-orange" id="user_search_btn">Search</button>
            <button type="button" class="btn blue" id="user_add_favorite_btn"> Save As Favorite</button>
            <button type="reset" class="btn default resetClassMain" id="user_reset_btn"> Reset</button>
          </div>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Admin'
}
</script>



// WEBPACK FOOTER //
// src/components/admin/SearchDialog.vue